import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
    ApplyRoomChange,
  GetBedMasterById,
  GetRoomMaster,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import { GetFeeApprovedList } from '../../../AllAPI/AdminAPI'

const StudentRoomChange = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const [allotModalOpen, setAllotModalOpen] = useState(false)
  const [rooms, setRooms] = useState([])
  const [beds, setBeds] = useState([])
  const [selectedRoomId, setSelectedRoomId] = useState(null)
  const [selectedBedId, setSelectedBedId] = useState(null)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState('')

  useEffect(() => {
    fetchFeeApprovedStudentList()
  }, [])

  const fetchRooms = async () => {
    try {
      const res = await axios.get(`${GetRoomMaster}/${storedBranchId}`)
      setRooms(res.data)
    } catch (err) {
      toast.error('Failed to load rooms')
    }
  }

  const fetchBeds = async (roomId) => {
    try {
      const res = await axios.get(
        `${GetBedMasterById}/${storedBranchId}/${roomId}`,
      )
      setBeds(res.data)
    } catch (err) {
      toast.error('Failed to load beds')
    }
  }

  const fetchFeeApprovedStudentList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetFeeApprovedList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.hostel_tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const handleApproval = async () => {
    if (!selectedRecord) return

    const today = new Date().toISOString().split('T')[0]

    const body = {
      reg_id: parseInt(selectedRecord.reg_id),
      branch_id: parseInt(selectedRecord.branch_id),
      oldroom_id: parseInt(selectedRecord.roombooking.room_id),
      oldbed_id: parseInt(selectedRecord.roombooking.bed_id),

      // 👉 Use selected room/bed from allocation modal
      newroom_id: parseInt(selectedRoomId),
      newbed_id: parseInt(selectedBedId),
      change_date: today,
      year: parseInt(BoardingYear),
    }

    try {
      setLoading(true)
      const res = await axios.put(ApplyRoomChange, body)

      if (res.data === 'BEDNOTAVAILABLE') {
        toast.warn('Bed not available')
      } else if (res.data === 'REQUIRED') {
        toast.warn('Required data not found!')
      } else if (res.data === 'ROOMCHANGED') {
        toast.success('Room changed successfully!')

        setConfirmChecked(false)
        setAllotModalOpen(false)
        setSelectedRoomId(null)
        setSelectedBedId(null)
        fetchFeeApprovedStudentList()
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading(false)
    }
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Student Room Change</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-12 py-2">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span style={{fontSize:"18px",backgroundColor:"#f8ff90ff",padding:"2px 10px"}}>{selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                        {selectedRecord.s_lname}</span>
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-12 py-2">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-4">
                        <span style={labelCss}>Room No:</span>
                         <p className="shadow py-3 px-3 rounded" style={{backgroundColor:"#dee9fc"}}>{selectedRecord.roombooking.room.room_no}</p>                        
                      </div>
                      <div className="col-md-4">
                        <span style={labelCss}>Bed No:</span>
                        <p className="shadow py-3 px-3 rounded" style={{backgroundColor:"#d6fce3"}}>{selectedRecord.roombooking.bed.bed_no}</p>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
               

                <Button
                  danger
                  disabled={!confirmChecked}
                  onClick={() => {
                    setViewModalOpen(false)
                    setConfirmChecked(false)
                  }}
                >
                  Cancel
                </Button>

                 <Button
                  type="primary"
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => {
                    setViewModalOpen(false)
                    setAllotModalOpen(true)
                    setConfirmChecked(false)
                    fetchRooms()
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* =================== ROOM CHANGE MODAL =================== */}
      <Modal
        // className="custom-alloc-modal"
        title="Room Change"
        open={allotModalOpen}
        onCancel={() => {
          setAllotModalOpen(false)
          setSelectedRoomId(null)
          setSelectedBedId(null)
        }}
        width={900}
        footer={null}
      >
        {/* Rooms */}
        <h5 className="section-title">Select Room</h5>
        <div className="row">
          {rooms.map((room) => {
            const isOccupied = room.status === 2
            const isSelected = selectedRoomId === room.room_id

            return (
              <div className="col-md-3 mb-3" key={room.room_id}>
                <div
                  className={`
                            room-card
                            ${isOccupied ? 'room-occupied' : ''}
                            ${isSelected ? 'room-selected' : ''}
                            `}
                  onClick={() => {
                    if (!isOccupied) {
                      setSelectedRoomId(room.room_id)
                      setSelectedBedId(null)
                      fetchBeds(room.room_id)
                    }
                  }}
                  style={{ cursor: isOccupied ? 'not-allowed' : 'pointer' }}
                >
                  <b>Room {room.room_no}</b>
                  <br />
                  <br />
                  {isOccupied && <small>(Occupied)</small>}
                </div>
              </div>
            )
          })}
        </div>

        {/* Beds */}
        {selectedRoomId && (
          <>
            <h5 className="section-title">Select Bed</h5>
            <div className="row">
              {beds.map((bed) => {
                const bedOccupied = bed.status === 2
                const bedSelected = selectedBedId === bed.bed_id

                return (
                  <div className="col-md-3 mb-3" key={bed.bed_id}>
                    <div
                      className={`
                                bed-card
                                ${bedOccupied ? 'bed-occupied' : ''}
                                ${bedSelected ? 'bed-selected' : ''}
                                `}
                      onClick={() => {
                        if (!bedOccupied) setSelectedBedId(bed.bed_id)
                      }}
                      style={{
                        cursor: bedOccupied ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <b>{bed.bed_no}</b>
                      <br />
                      {bedOccupied ? 'Occupied' : 'Available'}
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-3 mt-3">
          <Button
            danger
            onClick={() => {
              setAllotModalOpen(false)
              setSelectedRoomId(null)
              setSelectedBedId(null)
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            disabled={!selectedRoomId || !selectedBedId}
            loading={loading}
            onClick={() => {
              setAllotModalOpen(false)
              handleApproval()
            }}
          >
            Change
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default StudentRoomChange
